import {createAction, createSlice} from '@reduxjs/toolkit';

export const expenseInitialState = {
  parameter: [],
  download: '',
  uploadResponse: [],
  saveRes: [],
  isLoading: false,
};
export const fetchExpenseParameterCreator = createAction(
  'EXPENSE_HANDLER/FETCH_PARAMETER',
);
export const fetchExpenseParameterCreatorTypeName =
  fetchExpenseParameterCreator().type;

export const fetchDownloadCreator = createAction<any>(
  'EXPENSE_HANDLER/FETCH_DOWNLOAD',
);
export const fetchDownloadCreatorTypeName = fetchDownloadCreator(null).type;

export const fileUploadCreator = createAction<any>(
  'EXPENSE_HANDLER/FILEUPLOAD',
);
export const fileUploadCreatorTypeName = fileUploadCreator(null).type;

export const fetchExpenseFileNumberCreator = createAction<any>(
  'EXPENSE_HANDLER/FETCH_EXPENSE_FILE_NUMBER',
);
export const fetchExpenseFileNumberTypeName =
  fetchExpenseFileNumberCreator(null).type;

export const downloadExpenseFileNumberTempCreator = createAction<any>(
  'EXPENSE_HANDLER/DOWNLOAD_EXPENSE_FILE_NUMBER_TEMP',
);
export const downloadExpenseFileNumberTempTypeName =
  downloadExpenseFileNumberTempCreator(null).type;

const expenseStateHandler = createSlice({
  name: 'EXPENSE_HANDLER',
  initialState: expenseInitialState,
  reducers: {
    setParameter: (prevState, action) => {
      const {payload} = action;
      return {
        ...prevState,
        parameter: payload,
      };
    },
    setDownload: (prevState, action) => {
      const {payload} = action;
      return {
        ...prevState,
        download: payload,
      };
    },
    setUploadResponse: (prevState, action) => {
      const {payload} = action;
      return {
        ...prevState,
        uploadResponse: payload,
      };
    },
    setSaveRes: (prevState, action) => {
      const {payload} = action;
      return {
        ...prevState,
        saveRes: payload,
      };
    },
    setIsLoading: (prevState, action) => {
      const {payload} = action;
      return {
        ...prevState,
        isLoading: payload,
      };
    },
  },
});
export const expenseStateActions = expenseStateHandler.actions;
export const expenseStateReducer = expenseStateHandler.reducer;
